import { cacheGetters } from './cache'

export default {
  ...cacheGetters,
}
